export const LoadingComp = () => {
  return (
    <>
      <div className="overlay"></div>
      <div className="spinner">
        <div className="loader"></div>
        <p>Loading...</p>
      </div>
    </>
  );
};
